import { useQuery } from "@tanstack/react-query";

import { getTechnicalJobs, type TechnicalJob } from "@/api/print-image-api";
import { FIVE_MINUTES_MS } from "@/constants";

type DropdownOption = {
	key: number;
	text: string;
	value: string;
};

const formatJobsToOptions = (jobs: TechnicalJob[]): DropdownOption[] =>
	jobs.map((job, i) => ({
		key: i,
		text: `${job.title} (${job.id})`,
		value: job.title,
	}));

export const useTechnicalJobs = (iotHubName: string, iotEdgeDeviceId: string) => {
	const query = useQuery({
		queryKey: ["technical-jobs", iotHubName, iotEdgeDeviceId],
		queryFn: () => getTechnicalJobs(iotHubName, iotEdgeDeviceId),
		enabled: Boolean(iotHubName && iotEdgeDeviceId),
		select: formatJobsToOptions,
		staleTime: FIVE_MINUTES_MS,
		retry: false,
	});

	return {
		technicalJobs: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
	};
};
